import { render } from "./CreateNoteModal.vue?vue&type=template&id=792a26b5&ts=true"
import script from "./CreateNoteModal.vue?vue&type=script&lang=ts"
export * from "./CreateNoteModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__